import TagManager from 'react-gtm-module';
import { configuration } from '../utils/environment';
import { DataLayerObject } from './types';
// Following https://github.com/sahava/datalayer-typescript.
export const COOKIE_CONSENT_KEY = 'imt-cookie-consent';

export function getCookieConsent() {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(COOKIE_CONSENT_KEY);
}

export function initializeAnalytics() {
  const consent = getCookieConsent();
  if (consent === 'all' && configuration.googleTagManager) {
    const tagManagerArgs = {
      gtmId: configuration.googleTagManager.containerId,
      auth: configuration.googleTagManager.environmentAuthorizationCode,
      preview: configuration.googleTagManager.environmentName
    };
    TagManager.initialize(tagManagerArgs);
  }
}

export function trackAnalyticsEvent(
  category: string,
  action: string,
  label?: string,
  value?: number,
  nonInteraction?: boolean
) {
  const dataLayer: DataLayerObject = {
    event: 'customEvent',
    eventData: {
      category,
      action,
      label,
      value,
      nonInteraction
    }
  };
  pushToDataLayer(dataLayer);
}

function pushToDataLayer(dataLayer: DataLayerObject) {
  TagManager.dataLayer({ dataLayer: dataLayer });
}
